export enum ProductType {
    Evaluate = 0,
    Enquire = 1,
    Improve = 2,
    Develop = 3,
}

export const getProductTypeName = (type: ProductType): string => {
    switch(type) {
        case ProductType.Evaluate:
            return "Evaluate";
        case ProductType.Enquire:
            return "Enquire";
        case ProductType.Improve:
            return "Track";
        case ProductType.Develop:
            return "Develop"; // this might need to be changed to observe depending on how we impliment develop
        default:
            return "Unknown";
    }
}

export const getProductTypePathSegment = (type: ProductType): string => {
    switch(type) {
        case ProductType.Evaluate:
            return "evaluate";
        case ProductType.Improve:
            return "improve";
        case ProductType.Develop:
            return "develop";
        case ProductType.Enquire:
            return "enquire";
        default:
            return "unknown";
    }
}